import { render, staticRenderFns } from "./StepSettings.vue?vue&type=template&id=c6169bfc&"
import script from "./StepSettings.vue?vue&type=script&lang=js&"
export * from "./StepSettings.vue?vue&type=script&lang=js&"
import style0 from "./StepSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports